import  {useState,useEffect} from 'react';
import './CountdownTimer.css';

type TimerProps = {
    handleTimedOut: () => void
};

function CountdownTimer(props: TimerProps) {
    const [remainingTime,setRemainingTime] = useState(-1);

    useEffect(() => {
      setRemainingTime(15*60);
      const intervalId = setInterval(() => {
        setRemainingTime(prevRemainingTime => prevRemainingTime - 1);
      },1000);
      return () => {
        clearInterval(intervalId);
      };
    },[]);

    useEffect(() => {
      if(remainingTime === 0){
        props.handleTimedOut();
      }
    },[remainingTime,props]);

    return(
      <p className="CountdownTimer">タイマー:{remainingTime}</p>
    );
}

export default CountdownTimer;
